import { SHOP_CRITERIA_ATTRIBUTE_ALLOWLIST_NAMES } from './shopCriteriaAttributeAllowlist';

export const getCriteriaError = (attribute: string, _values?: readonly string[]): string | null => {
    if (!SHOP_CRITERIA_ATTRIBUTE_ALLOWLIST_NAMES.has(attribute)) {
        return `attribute "${attribute}" is not allowed`;
    }

    return null;
};

export const addCriteriaIssue = (
    item: { attribute: string; value: readonly string[] },
    ctx: { addIssue: (issue: { code: 'custom'; message: string }) => void }
): void => {
    const message = getCriteriaError(item.attribute);

    if (message) {
        ctx.addIssue({ code: 'custom', message });
    }
};
